const conf = {
  // baseurl: "http://35.154.235.214/api",
  // baseurl: "http://localhost:5000/api",
  baseurl: "https://ecr.bluevistallc.com/api",
};
export default conf;
